<template>
  <div class="wrap">
    <div class="pc-footerBar" v-if="isMobile">
      <div class="logo">
        <img :src="oosUrl+'/img/footLogo.png'" alt="" />
      </div>
      <div class="extend">
        <div class="extendList">
          <div class="item" v-for="(v, k) in mode" :key="k">
            <div class="icon">
              <img :src="v.url" alt="" />
            </div>
          </div>
        </div>
      </div>
      <div class="num">
        <a href="https://beian.miit.gov.cn/" target="_blank">沪ICP备17056175号-2</a>
      </div>
    </div>

    <!-- webPc端 -->
    <div class="footerBar" v-else>
      <div class="extend">
        <div class="extendList">
          <div class="item" v-for="(v, k) in mode" :key="k">
            <div class="icon">
              <img :src="v.url" alt="" />
            </div>
          </div>
        </div>
      </div>
      <div class="num">
        <a href="https://beian.miit.gov.cn/" target="_blank">沪ICP备2022026327号-1</a>
      </div>
    </div>
  </div>
</template>

<script>
import utils from "@/utils/utils";
export default {
  name: "footerBar",
  data() {
    return {
      isMobile: true,
      oosUrl: "https://blue-dash.oss-cn-shanghai.aliyuncs.com",
      mode: [
        {
          url: "https://blue-dash.oss-cn-shanghai.aliyuncs.com/img/contact/icon1.jpg",
          name: "@ BLUE DASH 布鲁大师",
        },
        {
          url: "https://blue-dash.oss-cn-shanghai.aliyuncs.com/img/contact/icon2.jpg",
          name: "@ BLUE DASH 布鲁大师",
        },
        {
          url: "https://blue-dash.oss-cn-shanghai.aliyuncs.com/img/contact/icon3.jpg",
          name: "@ BLUE DASH 布鲁大师",
        },
        {
          url: "https://blue-dash.oss-cn-shanghai.aliyuncs.com/img/contact/icon4.jpg",
          name: "@ BLUEDASH布鲁大师",
        },
        {
          url: "https://blue-dash.oss-cn-shanghai.aliyuncs.com/img/contact/icon5.jpg",
          name: "@ bluedash.official",
        },
        {
          url: "https://blue-dash.oss-cn-shanghai.aliyuncs.com/img/contact/icon6.jpg",
          name: "@ BLUE DASH.Official",
        },
      ],
    };
  },
  mounted() {
    this.isMobile = utils.isMobile();
  },
  methods: {
    handelTab(path) {
      this.$router.push({ path });
    },
  },
};
</script>

<style scoped lang="less">
.pc-footerBar {
  width: 1920px;
  background: #000000;
  padding: 60px 0 50px;
  box-sizing: border-box;

  .logo {
    width: 260px;
    display: block;
    padding: 12px 0 20px;
    margin: auto;

    img {
      width: 260px;
      height: 33px;
    }
  }

  .nav {
    display: flex;
    justify-content: center;
    text-align: center;

    li {
      margin: 30px 20px;
      font-weight: 400;
      color: #ffffff;
      line-height: 35px;
      text-align: center;
      cursor: pointer;

      .chinese {
        font-size: 18px;
      }

      .eng {
        font-size: 15px;
      }
    }
  }

  .extend {
    .title {
      font-size: 25px;
      color: #fff;
      font-weight: 500;
      line-height: 35px;
      text-align: center;
    }

    .extendList {
      margin: 32px 0 42px;
      display: flex;
      justify-content: center;

      .item {
        display: flex;
        flex-direction: column;
        align-items: center;
        cursor: pointer;
        margin-right: 60px;

        &:nth-last-of-type(1) {
          margin: 0;
        }

        .icon {
          width: 52px;
          height: 52px;

          img {
            width: 100%;
            height: 100%;
            border-radius: 50%;
          }
        }

        .name {
          font-size: 17px;
          font-weight: 400;
          color: #ffffff;
          line-height: 24px;
          margin-top: 10px;
        }
      }
    }

    .mode {
      font-size: 21px;
      font-weight: 400;
      color: #fff;
      margin-bottom: 40px;
      cursor: pointer;

      img {
        width: 40px;
        height: 40px;
        margin-right: 20px;
      }
    }
  }

  .num {
    font-size: 14px;
    font-weight: 300;
    line-height: 20px;
    text-align: center;

    a {
      color: #fff;
      text-decoration: none;
    }
  }
}

.footerBar {
  width: 1920px;
  background: #000000;
  padding: 10px;
  box-sizing: border-box;

  .logo {
    width: 260px;
    padding: 6px 0 10px;
    margin: 0 auto;

    img {
      width: 260px;
    }
  }

  .nav {
    display: flex;
    justify-content: center;
    text-align: center;
    li {
      margin: 50px 20px;
      font-size: 40px;
      font-weight: 400;
      color: #ffffff;
      line-height: 20px;
      cursor: pointer;
    }
  }

  .extend {
    .title {
      font-size: 25px;
      color: #fff;
      font-weight: 500;
      line-height: 40px;
      text-align: center;
    }

    .extendList {
      margin: 30px 0;
      display: flex;
      justify-content: center;

      .item {
        display: flex;
        flex-direction: column;
        align-items: center;
        cursor: pointer;
        margin-right: 30px;

        &:nth-last-of-type(1) {
          margin: 0;
        }

        .icon {
          width: 60px;
          height: 60px;

          img {
            width: 100%;
            height: 100%;
            border-radius: 50%;
          }
        }

        .name {
          font-size: 17px;
          font-weight: 400;
          color: #ffffff;
          line-height: 20px;
          margin-top: 25px;
        }
      }
    }
  }

  .num {
    font-size: 12px;
    font-weight: 300;
    line-height: 25px;
    text-align: center;

    a {
      color: #fff;
      text-decoration: none;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/FooterBar.vue